import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { Hero } from '@/components/sections/Hero';
import { TargetAudience } from '@/components/sections/TargetAudience';
import { PainPoints } from '@/components/sections/PainPoints';
import { HowItWorks } from '@/components/sections/HowItWorks';
import { SaleTypes } from '@/components/sections/SaleTypes';
import { WhyUs } from '@/components/sections/WhyUs';
import { FinalCTA } from '@/components/sections/FinalCTA';
import { FAQ } from '@/components/sections/FAQ';
import { Contact } from '@/components/sections/Contact';

export default function Index() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <TargetAudience />
        <PainPoints />
        <HowItWorks />
        <SaleTypes />
        <WhyUs />
        <FinalCTA />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
